import user from './user';
import toaster from './toaster';

const actions = {
    user,
    toaster,
};

export default actions;
